import { render, staticRenderFns } from "./ReportsDeliveryDriverView.vue?vue&type=template&id=837d867c"
import script from "./ReportsDeliveryDriverView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryDriverView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports